import {store} from '../../App';
import config from '../../config';

let axios     = require('axios'),
    download  = require('js-file-download'),
    io        = require('../io/index').actions,
    i18n      = require('i18next');

export const actiontypes = {
  TRACK_ARTWORK_UPLOAD_SUCCESS: 'TRACK_ARTWORK_UPLOAD_SUCCESS',
  TRACK_ARTWORK_DELETE_SUCCESS: 'TRACK_ARTWORK_DELETE_SUCCESS',
}
export const actions = {
  uploadTrackArtwork: (track, image) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).tracks.artwork.upload;

      let formData = new FormData();
      formData.append("image", image);

      axios.post(`${config.API_ADDRESS}/file/image/${track._id}`, formData, {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackUploadArtworkSuccess(json));
        dispatch(io.message(messages.success,'success', false));
      })
      .catch(err => dispatch(io.message(`${messages.error} (${err.message})`, 'error', false)));
    }
  },
  deleteTrackArtwork: (track) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).tracks.artwork.delete;

      axios.delete(`${config.API_ADDRESS}/file/image/${track._id}`, {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackDeleteArtworkSuccess(json));
        dispatch(io.message(messages.delete.success,'success', false));
      })
      .catch(err => dispatch(io.message(`${messages.error} (${err.message})`, 'error', false)));
    }
  },
  downloadTrackArtwork: (track) => {
    return dispatch => {
      axios.get(`${config.API_ADDRESS}/file/image/${track._id}?quality=high`, {
          responseType: 'arraybuffer'
      })
      .then(res => res.data)
      .then(json => {
        download(json, `${track.title}.jpg`);
      })
      .catch(err => dispatch(io.message(err.message, 'error', false)));
    }
  }
}

function trackUploadArtworkSuccess(track) {
  return {
    type: actiontypes.TRACK_ARTWORK_UPLOAD_SUCCESS,
    track
  }
}

function trackDeleteArtworkSuccess(track) {
  return {
    type: actiontypes.TRACK_ARTWORK_DELETE_SUCCESS,
    track
  }
}



// WEBPACK FOOTER //
// ./src/actions/tracks/artwork.js